var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M17.5547 4.35829C16.2131 4.22496 14.8714 4.12496 13.5214 4.04996V4.04163L13.3381 2.95829C13.2131 2.19163 13.0297 1.04163 11.0797 1.04163H8.89639C6.95472 1.04163 6.77139 2.14163 6.63805 2.94996L6.46305 4.01663C5.68805 4.06663 4.91305 4.11663 4.13805 4.19163L2.43805 4.35829C2.08805 4.39163 1.83805 4.69996 1.87139 5.04163C1.90472 5.38329 2.20472 5.63329 2.55472 5.59996L4.25472 5.43329C8.62139 4.99996 13.0214 5.16663 17.4381 5.60829C17.4631 5.60829 17.4797 5.60829 17.5047 5.60829C17.8214 5.60829 18.0964 5.36663 18.1297 5.04163C18.1547 4.69996 17.9047 4.39163 17.5547 4.35829Z",
          fill: _vm.color
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M16.0213 6.78337C15.8213 6.57504 15.5463 6.45837 15.263 6.45837H4.72963C4.44629 6.45837 4.16296 6.57504 3.97129 6.78337C3.77963 6.99171 3.67129 7.27504 3.68796 7.56671L4.20463 16.1167C4.29629 17.3834 4.41296 18.9667 7.32129 18.9667H12.6713C15.5796 18.9667 15.6963 17.3917 15.788 16.1167L16.3046 7.57504C16.3213 7.27504 16.213 6.99171 16.0213 6.78337ZM11.3796 14.7917H8.60463C8.26296 14.7917 7.97963 14.5084 7.97963 14.1667C7.97963 13.825 8.26296 13.5417 8.60463 13.5417H11.3796C11.7213 13.5417 12.0046 13.825 12.0046 14.1667C12.0046 14.5084 11.7213 14.7917 11.3796 14.7917ZM12.0796 11.4584H7.91296C7.57129 11.4584 7.28796 11.175 7.28796 10.8334C7.28796 10.4917 7.57129 10.2084 7.91296 10.2084H12.0796C12.4213 10.2084 12.7046 10.4917 12.7046 10.8334C12.7046 11.175 12.4213 11.4584 12.0796 11.4584Z",
          fill: _vm.color
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }